/*  ==========================================================================
    HANDLEBARS HELPERS
    Useful custom handlebar helpers.

    INFO:
    - add your helpers here
    ========================================================================== */

/*
 * IMPORTS
 */

// node
import Handlebars from 'handlebars/runtime';
import 'lodash/lodash.js';
import moment from 'moment/src/moment';
import 'moment/src/locale/de';
import 'moment/src/locale/it';

// local imports
import * as vars from '../../globals/variables';


/* GENERAL HELPERS
 * --------------------------------------------------------------------------- */

/*
 * CONVERT DATE
 */

// v1 (simple date converter)
Handlebars.registerHelper('date--convert', function(date) {
    date = $.datepicker.parseDate('yy-mm-dd', date);
    return $.datepicker.formatDate('dd.mm.yy', date);
});

// v2 (date converter with "moment.js")
Handlebars.registerHelper('date--convert-moment', function(date, format) {
    if (moment) {
        let f = format || 'DD.MM.YYYY';
        return moment(date).format(f);
    } else {
        return items;
    }
});

// v3 (convert date to a format for sorting)
Handlebars.registerHelper('date--convert-to-sort', function(date) {
    date = $.datepicker.parseDate('yy-mm-dd', date);
    return $.datepicker.formatDate('yymmdd', date);
});

/*
 * TRUNCATE TEXT
 */

Handlebars.registerHelper ('truncate--text', function (str, len) {
    if (str.length > len) {
        let new_str = str.substr (0, len+1);
        while (new_str.length) {
            let ch = new_str.substr ( -1 );
            new_str = new_str.substr ( 0, -1 );
            if (ch == ' ') {
                break;
            }
        }
        if ( new_str == '' ) {
            new_str = str.substr ( 0, len );
        }
        return new Handlebars.SafeString ( new_str +'...' );
    }
    return str;
});

/*
 * LOOP
 */

// each up to (to set a limit)
Handlebars.registerHelper('each--up-to', function(ary, max, options) {
    if(!ary || ary.length == 0)
        return options.inverse(this);
    let result = [ ];
    for(let i = 0; i < max && i < ary.length; ++i)
        result.push(options.fn(ary[i]));
    return result.join('');
});

// do something x times
Handlebars.registerHelper('each--times', function(n, block) {
    let accum = '';
    for(let i = 0; i < n; ++i)
        accum += block.fn(i);
    return accum;
});

// every nth
Handlebars.registerHelper('each--every-nth', function(context, every, options) {
    let fn = options.fn, inverse = options.inverse;
    let ret = '';
    if(context && context.length > 0) {
        for(let i=0, j=context.length; i<j; i++) {
            let modZero = i % every === 0;
            ret = ret + fn(_.extend({}, context[i], {
                isModZero: modZero,
                isModZeroNotFirst: modZero && i > 0,
                isLast: i === context.length - 1
            }));
        }
    } else {
        ret = inverse(this);
    }
    return ret;
});

/*
 * COUNTER
 */

// counter
let handlebarsCounter = 1;
Handlebars.registerHelper('counter', function() {
    return handlebarsCounter++;
});

// rhythm of three
Handlebars.registerHelper('rhythm--three', function(index, value1, value2, value3) {
    let indexProcessed = index + 1,
        temp = 0,
        value = '';
    for (let i = indexProcessed; i > 0; i = i - 3) {
        temp = i;
    }
    if (temp === 3) {
        value = value3;
    } else if (temp === 2) {
        value = value2;
    } else {
        value = value1;
    }
    return value;
});

/*
 * FORMAT PRICE
 */

// v1 (f.e. "100,00")
Handlebars.registerHelper('currency--comma', function(amount, options) {
    if (typeof(amount) === 'string') {
        amount = options.contexts[0].get(amount);
    }
    let rounded = Math.round(amount * 100);
    let dec = rounded % 100;
    let whole = rounded / 100 - dec / 100;
    let wholeFormated = whole.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    let decStr = '' + dec;
    return wholeFormated + ',' + decStr + ( decStr.length < 2 ? '0' : '');
});

// v2 (f.e. "100.00")
Handlebars.registerHelper('currency--dot', function(amount, options) {
    if (typeof(amount) === 'string') {
        amount = options.contexts[0].get(amount);
    }
    let rounded = Math.round(amount * 100);
    let dec = rounded % 100;
    let whole = rounded / 100 - dec / 100;
    let decStr = '' + dec;
    return whole + '.' + decStr + ( decStr.length < 2 ? '0' : '');
});

// v3 (customizable)
Handlebars.registerHelper('currency--custom', function(amount, divider) {
    if (typeof(amount) === 'string') {
        amount = parseFloat(amount);
    }
    let rounded = Math.round(amount * 100);
    let dec = rounded % 100;
    let whole = rounded / 100 - dec / 100;
    let wholeFormated = whole.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    let decStr = '' + dec;
    return wholeFormated + divider + decStr + ( decStr.length < 2 ? '0' : '');
});

/*
 * COMPARE
 */

// if condition
Handlebars.registerHelper('if--cond', function(v1, v2, options) {
    if(v1 === v2) {
        return options.fn(this);
    }
    return options.inverse(this);
});

// if value
Handlebars.registerHelper('if--value', function (conditional, options) {
    if (options.hash.value === conditional) {
        return options.fn(this)
    } else {
        return options.inverse(this);
    }
});

// if equals
Handlebars.registerHelper('if--equals', function(conditional, value, options) {
    if (conditional === value){
        return options.fn(this);
    } else {
        return options.inverse(this);
    }
});

// if equals v2
Handlebars.registerHelper('if--equals-v2', function(lvalue, rvalue, options) {
    if (arguments.length < 3)
        throw new Error("Handlebars Helper equal needs 2 parameters");
    if( lvalue!=rvalue ) {
        return options.inverse(this);
    } else {
        return options.fn(this);
    }
});

// if even
Handlebars.registerHelper('if--even', function(conditional, options) {
    let index = conditional + 1;
    if((index % 2) == 0) {
        return options.fn(this);
    } else {
        return options.inverse(this);
    }
});

// compare
Handlebars.registerHelper('compare', function(lvalue, rvalue, options) {
    if (arguments.length < 3)
        throw new Error("Handlerbars Helper 'compare' needs 2 parameters");
    let operator = options.hash.operator || "==";
    let operators = {
        '==':       function(l,r) { return l == r; },
        '===':      function(l,r) { return l === r; },
        '!=':       function(l,r) { return l != r; },
        '<':        function(l,r) { return l < r; },
        '>':        function(l,r) { return l > r; },
        '<=':       function(l,r) { return l <= r; },
        '>=':       function(l,r) { return l >= r; },
        'typeof':   function(l,r) { return typeof l == r; }
    };
    if (!operators[operator])
        throw new Error("Handlerbars Helper 'compare' doesn't know the operator "+operator);
    let result = operators[operator](lvalue,rvalue);
    if( result ) {
        return options.fn(this);
    } else {
        return options.inverse(this);
    }
});

// ternary operator
Handlebars.registerHelper('ternary-operator', function(value) {
    if (value < 10) {
        return '0'+value;
    } else {
        return value;
    }
});

/*
 * CALCULATIONS
 */

Handlebars.registerHelper('calc', function(lvalue, operator, rvalue, options) {
    lvalue = parseFloat(lvalue);
    rvalue = parseFloat(rvalue);
    return {
        '+': lvalue + rvalue,
        '-': lvalue - rvalue,
        '*': lvalue * rvalue,
        '/': lvalue / rvalue,
        '%': lvalue % rvalue
    }[operator];
});

/*
 * CHAIN
 */

// multiple helpers on a single tag
Handlebars.registerHelper('chain', function() {
    let helpers = [];
    let args = Array.prototype.slice.call(arguments);
    let argsLength = args.length;
    let index;
    let arg;
    for (index = 0, arg = args[index];
         index < argsLength;
         arg = args[++index]) {
        if (Handlebars.helpers[arg]) {
            helpers.push(Handlebars.helpers[arg]);
        } else {
            args = args.slice(index);
            break;
        }
    }
    while (helpers.length) {
        args = [helpers.pop().apply(Handlebars.helpers, args)];
    }
    return args.shift();
});

/*
 * INDEX
 */

// increment index by 1
Handlebars.registerHelper('index-increment', function(value, options) {
    return parseInt(value) + 1;
});

/*
 * URL GENERATOR
 */

// encode a normal string url valid
Handlebars.registerHelper('url-encode', function (url) {
    return url
        .toLowerCase()
        .replace('ä','ae')
        .replace('ü','ue')
        .replace('ö','oe')
        .replace('ß','ss')
        .replace('&amp;','-')
        .replace(/\s/g,'-')
        .replace(' ','-')
        .replace('é','e')
        .replace('è','e')
        .replace(/[^a-zA-Z0-9-_]/g,'');
});


/* CUSTOM (F.E. PROJECT RELATED)
 * --------------------------------------------------------------------------- */

/*
 * EHOTELIER
 */

// generate dynamic offer Link (usage: {{offerLink  pageID offerID}}
// ! Attention: a tag for which this helper is used,
// should have following class name: "bn_offerLink_{{offerID}}")
Handlebars.registerHelper('offer-link', function(pageID, offerID) {
    let langID = $('body').attr('data-lang-id');
    let hotelID = $('body').attr('data-eh-hid');
    let ehotOfferTitle = 'offer-' + offerID + '-' + hotelID + '-' + langID;
    $.ajax({
        method: 'GET',
        url: '/?type=1001&page=' + pageID + '&language=' + langID + '&offer=' + ehotOfferTitle
    }).done(function (data) {
        $('.eh-offer-link-' + offerID).attr('href', data);
    });
});

// generate dynamic room Link (usage: {{roomLink  pageID roomID}}
// ! Attention: a tag for which this helper is used,
// should have following class name: "bn_roomLink_{{roomID}}")
Handlebars.registerHelper('room-link', function(pageID, roomID) {
    let langID = $('body').attr('data-lang-id');
    let hotelID = $('body').attr('data-eh-hid');
    let ehotRoomTitle = 'hoteldata-' + roomID + '-' + hotelID + '-' + langID;
    $.ajax({
        method: 'GET',
        url: '/?type=1002&page=' + pageID + '&language=' + langID + '&rooms=' + ehotRoomTitle
    }).done(function (data) {
        $('.eh-room-link-' + roomID).attr('href', data);
    });
});

/*
 * WUNDERGROUND WEATHER
 */

// translate "wunderground.com" weather icons (needs "underscore.js")
// for info look here "https://www.wunderground.com/about/icons.asp"
Handlebars.registerHelper('wg--weather-icon', function(icon) {
    let r = '',
        weatherArray = [
            {
                code: 'o',
                icon: 'chanceflurries',
            }, {
                code: 'j',
                icon: 'chancerain',
            }, {
                code: 'r',
                icon: 'chancesleat',
            }, {
                code: 'o',
                icon: 'chancesnow',
            }, {
                code: 'v',
                icon: 'chancetstorms',
            }, {
                code: 'a',
                icon: 'clear',
            }, {
                code: 'd',
                icon: 'cloudy',
            }, {
                code: 'p',
                icon: 'flurries',
            }, {
                code: 't',
                icon: 'hazy',
            }, {
                code: 'c',
                icon: 'mostlycloudy',
            }, {
                code: 'c',
                icon: 'mostlysunny',
            }, {
                code: 'b',
                icon: 'partlycloudy',
            }, {
                code: 'b',
                icon: 'partlysunny',
            }, {
                code: 'h',
                icon: 'rain',
            }, {
                code: 'r',
                icon: 'sleat',
            }, {
                code: 'p',
                icon: 'snow',
            }, {
                code: 'a',
                icon: 'sunny',
            }, {
                code: 'v',
                icon: 'tstorms',
            }, {
                code: 'k',
                icon: 'unknown',
            }
        ];
    r = _.where(weatherArray, {icon: icon}) || _.where(weatherArray, {icon: 'nt_' + icon});
    if (!r.length) {
        r = 'a';
    } else {
        r = r[0].code;
    }
    return r;
});

/*
 * GET DOMAIN
 */

// needs "domain" variable from "Build/source/js/globals/variables.js"
Handlebars.registerHelper('get-domain', function () {
    return vars.domain;
});


// WEBPACK FOOTER //
// ./source/js/utilities/lib/handlebars-helpers.js